
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/how-to-booking",
      function () {
        return require("private-next-pages/policy/how-to-booking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/how-to-booking"])
      });
    }
  